import React, { useEffect, useState } from 'react';
import loadingSvg from '../../assets/bounceLoad.svg';
import config from '../../config/config';
import { format } from 'date-fns';

function PaymentReceipt() {
  const { API_BASE_URL } = config;
  const payment_id = sessionStorage.getItem('paymentId');
  const [TransictionDetails, setTransictionDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!payment_id) {
      setError('Payment ID not found.');
      setLoading(false);
      return;
    }

    const fetchOrderDetails = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/Order/transiction_slip`, {
          method: 'GET',
          headers: {
            'PaymentId': payment_id,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) throw new Error('Failed to fetch transaction');

        const data = await response.json();
        setTransictionDetails(Array.isArray(data) ? data : [data]);
      } catch (err) {
        console.error(err);
        setError(err.message || 'An error occurred while fetching data.');
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [payment_id, API_BASE_URL]);

  if (loading)
    return (
      <div className="flex justify-center items-center h-screen px-4">
        <img className="h-24 w-24 sm:h-32 sm:w-32 animate-spin" src={loadingSvg} alt="Loading..." />
      </div>
    );

  if (error)
    return (
      <div className="text-center text-red-500 mt-10 px-4">
        <p>{error}</p>
      </div>
    );

  if (TransictionDetails.length === 0)
    return (
      <div className="text-center text-gray-500 mt-10 px-4">
        <p>No transaction details found.</p>
      </div>
    );

  return (
    <div className="bg-gray-100 flex flex-col items-center justify-center py-10 px-4">
      {TransictionDetails.map((slip) => (
        <div
          className="bg-white shadow-md rounded-lg w-full sm:w-4/5 md:w-3/5 lg:w-2/5 mb-10"
          key={slip.paymentId}
        >
          {/* Header */}
          <div className="bg-[#2563eb] text-white text-center py-8 rounded-t-lg">
            <img
              src="static/media/logo_3.53b1908a961faece3339.png"
              alt="Razorpay"
              className="mx-auto mb-2 w-40 h-16 sm:w-60 sm:h-20"
            />
          </div>

          {/* Body */}
          <div className="p-4 sm:p-6 md:p-8">
            {/* Payment Status */}
            <div className="text-center mb-6">
              <div className="text-2xl sm:text-3xl font-semibold text-gray-800">
                ₹{slip.amount}
              </div>
              <div className="text-green-500 font-medium text-lg sm:text-xl">
                Paid Successfully
              </div>
            </div>

            {/* Transaction Info */}
            <div className="border-t-4 border-[#2563eb] pt-4 space-y-2">
              <div className="flex justify-between text-sm sm:text-lg md:text-xl">
                <span className="font-medium text-gray-400">Payment Id:</span>
                <span className="text-gray-800 break-words">{slip.paymentId}</span>
              </div>
              <div className="flex justify-between text-sm sm:text-lg md:text-xl">
                <span className="font-medium text-gray-400">Track Order Id:</span>
                <span className="text-gray-800 break-words">{slip.hemorderId}</span>
              </div>
              <div className="flex justify-between text-sm sm:text-lg md:text-xl">
                <span className="font-medium text-gray-400">Paid On:</span>
                <span className="text-gray-800">
                  {format(new Date(slip.date), 'eeee, MMMM do, yyyy h:mm:ss a')}
                </span>
              </div>
              <div className="flex justify-between text-sm sm:text-lg md:text-xl">
                <span className="font-medium text-gray-400">Method:</span>
                <span className="text-gray-800">{slip.paymentMode}</span>
              </div>
              <div className="flex justify-between text-sm sm:text-lg md:text-xl">
                <span className="font-medium text-gray-400">Mobile Number:</span>
                <span className="text-gray-800">{slip.mobile || 'N/A'}</span>
              </div>
            </div>

            {/* Customer Info */}
            <div className="border-t border-gray-200 mt-4 pt-4 space-y-2">
              <div className="flex justify-between text-sm sm:text-lg md:text-xl">
                <span className="font-medium text-gray-400">Name:</span>
                <span className="text-gray-800">{slip.name || 'N/A'}</span>
              </div>
              <div className="flex justify-between text-sm sm:text-lg md:text-xl">
                <span className="font-medium text-gray-400">Email:</span>
                <a href={`mailto:${slip.email}`} className="text-blue-500 truncate max-w-[60%] sm:max-w-[70%]">
                  {slip.email}
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default PaymentReceipt;




// import React, { useEffect, useState } from 'react';
// import loadingSvg from '../../assets/bounceLoad.svg';
// import config from '../../config/config';
// import { format } from 'date-fns';

// function PaymentReceipt() {
//   const { API_BASE_URL } = config;
//   const payment_id = sessionStorage.getItem('paymentId');
//   const [TransictionDetails, setTransictionDetails] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!payment_id) {
//       setError('Payment ID not found.');
//       setLoading(false);
//       return;
//     }

//     const fetchOrderDetails = async () => {
//       try {
//         const response = await fetch(`${API_BASE_URL}/api/Order/transiction_slip`, {
//           method: 'GET',
//           headers: {
//             'PaymentId': payment_id,
//             'Content-Type': 'application/json',
//           },
//         });

//         if (!response.ok) throw new Error('Failed to fetch transaction');

//         const data = await response.json();
//         setTransictionDetails(Array.isArray(data) ? data : [data]);
//       } catch (err) {
//         console.error(err);
//         setError(err.message || 'An error occurred while fetching data.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchOrderDetails();
//   }, [payment_id, API_BASE_URL]);

//   if (loading)
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <img className="h-auto w-1/2" src={loadingSvg} alt="Loading..." />
//       </div>
//     );

//   if (error)
//     return (
//       <div className="text-center text-red-500 mt-10">
//         <p>{error}</p>
//       </div>
//     );

//   if (TransictionDetails.length === 0)
//     return (
//       <div className="text-center text-gray-500 mt-10">
//         <p>No transaction details found.</p>
//       </div>
//     );

//   return (
//     <div className="bg-gray-100 flex flex-col items-center justify-center py-10 px-2">
//       {TransictionDetails.map((slip) => (
//         <div
//           className="bg-white shadow-md rounded-lg w-full md:w-1/2 mb-10"
//           key={slip.paymentId}
//         >
//           <div className="bg-[#2563eb] text-white text-center py-10 rounded-t-lg">
//             <img
//               src="static/media/logo_3.53b1908a961faece3339.png"
//               alt="Razorpay"
//               className="mx-auto mb-2 w-60 h-20"
//             />
//           </div>

//           <div className="p-6 mb-4">
//             <div className="text-center mb-4">
//               <div className="text-3xl font-semibold text-gray-800">₹{slip.amount}</div>
//               <div className="text-green-500 font-medium">Paid Successfully</div>
//             </div>

//             <div className="border-t-4 border-[#2563eb] pt-4 px-6 md:px-12">
//               <div className="mb-2 flex justify-between text-xl">
//                 <span className="font-medium text-gray-400">Payment Id:</span>
//                 <span className="text-gray-800">{slip.paymentId}</span>
//               </div>
//               <div className="mb-2 flex justify-between text-xl">
//                 <span className="font-medium text-gray-400">Track Order Id:</span>
//                 <span className="text-gray-800">{slip.hemorderId}</span>
//               </div>
//               <div className="mb-2 flex justify-between text-xl">
//                 <span className="font-medium text-gray-400">Paid On:</span>
//                 <span className="text-gray-800">
//                   {format(new Date(slip.date), 'eeee, MMMM do, yyyy h:mm:ss a')}
//                 </span>
//               </div>
//               <div className="mb-2 flex justify-between text-xl">
//                 <span className="font-medium text-gray-400">Method:</span>
//                 <span className="text-gray-800">{slip.paymentMode}</span>
//               </div>
//               <div className="mb-2 flex justify-between text-xl">
//                 <span className="font-medium text-gray-400">Mobile Number:</span>
//                 <span className="text-gray-800">{slip.mobile || 'N/A'}</span>
//               </div>
//             </div>

//             <div className="border-t border-gray-200 mt-4 pt-4 px-6 md:px-12">
//               <div className="mb-2 flex justify-between text-xl">
//                 <span className="font-medium text-gray-400">Name:</span>
//                 <span className="text-gray-800">{slip.name || 'N/A'}</span>
//               </div>
//               <div className="mb-2 flex justify-between text-xl">
//                 <span className="font-medium text-gray-400">Email:</span>
//                 <a href={`mailto:${slip.email}`} className="text-blue-500">
//                   {slip.email}
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }

// export default PaymentReceipt;
